module.exports = __webpack_public_path__ + "img/b6a83ec59b81b89576e6d4c943f09dca.png";